import { useState, useEffect } from 'react';
import baseapi from '../../../../services/baseapi';
import { Loader2, ShieldAlert } from 'lucide-react';
import { showError } from '../../../../utils/toast';
import AgentSSH from '../../../Agent/AgentSSH';

interface FirewallSSHProps {
    asset_id: string | number;
    client_id: string | number;
}

export default function FirewallSSH({ asset_id, client_id }: FirewallSSHProps) {
    const [loading, setLoading] = useState(true);
    const [agentId, setAgentId] = useState<number | null>(null);

    useEffect(() => {
        if (!asset_id) return;
        (async () => {
            setLoading(true);
            try {
                const res = await baseapi.get("/firewall_asset_details", {
                    params: { query: JSON.stringify({ asset_id: parseInt(String(asset_id)), client_id: parseInt(String(client_id)) }) }
                });
                if (res.data?.status) {
                    const firewallData = Array.isArray(res.data.data) ? res.data.data[0] : res.data.data;
                    if (firewallData && firewallData.agent_id) {
                        setAgentId(firewallData.agent_id);
                    } else if (res.data.agent_id) {
                        setAgentId(res.data.agent_id);
                    }
                } else {
                    showError("Failed to load firewall details");
                }
            } catch (e: any) {
                showError(e.message);
            } finally {
                setLoading(false);
            }
        })();
    }, [asset_id, client_id]);

    if (loading) {
        return (
            <div className="flex items-center justify-center h-64">
                <Loader2 className="w-6 h-6 animate-spin text-orange-500" />
            </div>
        );
    }

    if (!agentId) {
        return (
            <div className="flex flex-col items-center justify-center h-64 gap-2 opacity-60">
                <ShieldAlert className="w-10 h-10 text-orange-400" />
                <p className="text-sm text-gray-200 font-bold uppercase tracking-widest">No associated Agent ID found for SSH</p>
            </div>
        );
    }

    return (
        <div className="w-full h-full min-h-[700px]">
            <AgentSSH agentId={agentId} clientId={client_id} hideHeader={true} />
        </div>
    );
}
